// Web Push Notification

document.addEventListener("DOMContentLoaded", function() {
    var webPsh = document.querySelector('.web-psh');
    var overlay = document.querySelector('.overlay');

    // Show .web-psh and overlay after 10 seconds
    setTimeout(function() {
        webPsh.style.display = 'flex';
        overlay.style.display = 'flex';
    }, 10000); // 10000 milliseconds = 10 seconds

    // Hide .web-psh and overlay when .n-thnk or .web-yes is clicked
    document.querySelectorAll('.n-thnk, .web-yes').forEach(function(element) {
        element.addEventListener('click', function() {
            webPsh.style.display = 'none';
            overlay.style.display = 'none';
        });
    });
});
